import { c as _c } from "react/compiler-runtime";
import { DatepickerSelectedDateType } from "@website/ui/datepicker";
import every from "lodash-es/every";
import isNaN from "lodash-es/isNaN";
import { useEffect, useState } from "react";
export const useDate = initialValues => {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [date, setDate] = useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setDate([]);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onEmptyDate = t1;
  let t2;
  if ($[2] !== initialValues) {
    t2 = () => {
      every(initialValues, _temp) ? setDate(initialValues) : setDate([]);
    };
    $[2] = initialValues;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== date) {
    t4 = {
      date,
      onChangeDate: setDate,
      onEmptyDate
    };
    $[5] = date;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
function _temp(date_0) {
  return !isNaN(date_0.year) && !isNaN(date_0.month) && !isNaN(date_0.day);
}